module.exports = __webpack_public_path__ + "img/img4.107b3aa2.svg";